import React from 'react';
import { Helmet } from 'react-helmet-async';
import AdminLayout from '../layouts/AdminLayout';
import BulletinManagement from '../components/BulletinManagement';
import { FileText } from 'lucide-react';

const AdminBulletins = () => {
  return (
    <AdminLayout>
      <Helmet>
        <title>Admin | Bulletin Management</title>
      </Helmet>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="py-4">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-semibold text-gray-900">Bulletin Management</h1>
            <div className="flex items-center text-primary">
              <FileText className="w-5 h-5 mr-2" />
              <span>Manage bulletins for website and employee portal</span>
            </div>
          </div>
          
          <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-4 mb-8">
            <h2 className="text-lg font-medium text-gray-900 mb-3">About Bulletin Management</h2>
            <p className="text-gray-600 mb-2">
              Use this tool to create and manage bulletin posts for both the public website and the employee portal.
            </p>
            
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="border border-gray-200 rounded-md p-3 bg-green-50">
                <h3 className="text-green-700 font-medium mb-1 flex items-center">
                  <span className="bg-green-100 text-green-700 p-1 rounded-full mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </span>
                  Public Bulletins
                </h3>
                <p className="text-sm text-gray-600">
                  Visible to everyone on the public website. Use for announcements, news, and information you want to share with clients and candidates.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-md p-3 bg-purple-50">
                <h3 className="text-purple-700 font-medium mb-1 flex items-center">
                  <span className="bg-purple-100 text-purple-700 p-1 rounded-full mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  Employee-Only Bulletins
                </h3>
                <p className="text-sm text-gray-600">
                  Only visible to employees in the employee portal. Use for internal announcements, policy updates, and company information.
                </p>
              </div>
            </div>
          </div>
          
          <BulletinManagement />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminBulletins; 